// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"_a15417"};